// Shared sizing for the contour SVG overlays (display + adjust).
// On-screen sizes are in CSS px and kept constant under zoom/rotation: lines
// use `vector-effect: non-scaling-stroke`, while radii/fonts are counter-scaled
// at render time (the overlay group carries the image->screen matrix).
// Arrowhead sizes are in image-pixel units (they scale with the image).
export const CONTOUR_STROKE = 2.5;
export const THIN_STROKE = 1;
export const CONNECTOR_STROKE = 1.5;
export const POINT_RADIUS = 5;
export const ENDPOINT_RADIUS = 3;
export const CENTROID_RADIUS = 15;
export const LABEL_FONT = 10;
export const ANNOTATION_FONT = 14;
export const ARROW_HEAD_LENGTH = 2;
export const ARROW_HEAD_WIDTH = 1;
